var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('BlockCurtain'),_c('MainMenu'),_c('transition',{attrs:{"name":"router-anim"},on:{"enter":_vm.transitionIn,"leave":_vm.transitionOut}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }